import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import { VENUE_USER_LIST_QUERY, VENUE_USER_READ_QUERY } from "./queries";
import {
  VENUE_USER_CREATE_MUTATION,
  VENUE_USER_DELETE_MUTATION,
  VENUE_USER_UPDATE_MUTATION,
} from "./mutations";
import {
  VenueUserRead,
  VenueUserReadVariables,
} from "./__generated__/VenueUserRead";
import {
  VenueUserList,
  VenueUserListVariables,
} from "./__generated__/VenueUserList";
import {
  VenueUserCreate,
  VenueUserCreateVariables,
} from "./__generated__/VenueUserCreate";
import {
  VenueUserUpdate,
  VenueUserUpdateVariables,
} from "./__generated__/VenueUserUpdate";
import {
  VenueUserDelete,
  VenueUserDeleteVariables,
} from "./__generated__/VenueUserDelete";

export const useVenueUserReadQuery = makeQueryHook<
  VenueUserRead,
  VenueUserReadVariables
>(VENUE_USER_READ_QUERY);

export const useVenueUserListQuery = makeQueryHook<
  VenueUserList,
  VenueUserListVariables
>(VENUE_USER_LIST_QUERY);

export const useVenueUserCreateMutation = makeMutationHook<
  VenueUserCreate,
  VenueUserCreateVariables
>(VENUE_USER_CREATE_MUTATION);

export const useVenueUserUpdateMutation = makeMutationHook<
  VenueUserUpdate,
  VenueUserUpdateVariables
>(VENUE_USER_UPDATE_MUTATION);

export const useVenueUserDeleteMutation = makeMutationHook<
  VenueUserDelete,
  VenueUserDeleteVariables
>(VENUE_USER_DELETE_MUTATION);
